module.exports = __webpack_public_path__ + "media/fall_2023_sweepstakes/answer-a4a35318.svg";